<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QvzXYH/tc-custom/9781452121383.jpg?1705233290850" alt="This image is the cover for the book Sweet on Texas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sweet on Texas
      </h1>
      <p class="bookDescription body article font2">
        <b>Take a sugar-coated tour through the Lone Star State with more than sixty recipes plus stories of master confectioners all across Texas.</b><br/><br/>This tantalizing tome features a hearty helping of must-eat recipes and must-meet dessert devotees, garnished with their fascinating stories. Southern cookbook author Denise Gee introduces you to local Texan bakeries, the youngest pastry chef in the state, and the proper way to organize a Southern cookie swap.<br/><br/>Divided into four tasty Texas regions, this cookbook features the big flavors of sweet treats like Deep Chocolate Meringue Pie, Citrus-Kissed Fig Ice Cream, Deep-Fried Coca-Cola, and Sweet Pineapple Tamales. With more than 60 classic and brand spankin’ new recipes for cakes, cookies, puddings, cobblers, ice cream, pies, and pastries, <i>Sweet on Texas</i> reveals the sweet side of Texan cuisine.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Denise Gee, Robert M. Peacock
      </h2>
      
      <p class="authorDescription body article">Denise Gee is the author of Southern Cocktails and Porch Parties. She lives in Dallas, Texas.Robert M. Peacock is a Dallas-based photographer.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2df00b2c